module.exports = __webpack_public_path__ + "static/media/3e6.b5b822c3.jpg";